import { getTokenLocal } from "utils/localStorage.util";
import ApiRoutes from "../configs/endpoints.config";
import HttpClient from "./index.api";
const baseURL = process.env.REACT_APP_API_URL;

class User extends HttpClient {
  constructor() {
    super(baseURL);
    this._initializeRequestInterceptor();
    this._initializeResponseInterceptor();
  }

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${getTokenLocal()}`;
      config.headers["ngrok-skip-browser-warning"] = "true";
      return config;
    });
  };
  _initializeResponseInterceptor = () => {
    this.instance.interceptors.response.use(
      (response) => {
        return response;
      },
      (response) => {
        return Promise.resolve(response);
      }
    );
  };

  AllUserConfig = ApiRoutes.User.AllUsers;
  UserByIdConfig = ApiRoutes.User.UserById;
  UserStatsConfig = ApiRoutes.User.UserStats;
  GetUserReportsConfig = ApiRoutes.User.GetUserReports;
  UpdateUserReportConfig = ApiRoutes.User.UpdateUserReportStatus;
  ToggleBlockUserConfig = ApiRoutes.User.ToggleBlockUser;
  searchPeopleDetailConfig = ApiRoutes.User.SearchPeopleDetail;
  usersSummaryConfig = ApiRoutes.User.UsersSummary;
  userFeatureAccessConfig = ApiRoutes.User.UserFeatureAccess;
  UserEnquiryConfig = ApiRoutes.User.UserEnquiry;
  userDailyConfig = ApiRoutes.User.UserDaily;
  userPagesConfig = ApiRoutes.User.UserPages;
  addUserNoteConfig = ApiRoutes.User.AddUserNote;
  adminTenantRatingSummaryConfig = ApiRoutes.User.AdminTenantRatingSummary;
  adminTenantRatingEventsConfig = ApiRoutes.User.AdminTenantRatingEvents;

  getAllUser = async (data) => {
    return this.instance({
      method: this.AllUserConfig.Method,
      url: this.AllUserConfig.Endpoint,
      headers: {},
      data: data,
    });
  };
  getUserById = async (data) => {
    return this.instance({
      method: this.UserByIdConfig.Method,
      url: this.UserByIdConfig.Endpoint,
      headers: {},
      data: data,
    });
  };

  getUserReports = async () => {
    return this.instance({
      method: this.GetUserReportsConfig.Method,
      url: this.GetUserReportsConfig.Endpoint,
    });
  };

  updateUserReportStatus = async (data) => {
    return this.instance({
      method: this.UpdateUserReportConfig.Method,
      url: this.UpdateUserReportConfig.Endpoint,
      data,
    });
  };

  toggleBlockUser = async ({ userId }) => {
    return this.instance({
      method: this.ToggleBlockUserConfig.Method,
      url: this.ToggleBlockUserConfig.Endpoint(userId),
    });
  };

  addUserNote = async ({ userId, adminNote }) => {
    return this.instance({
      method: this.addUserNoteConfig.Method,
      url: `${this.addUserNoteConfig.Endpoint}/${userId}`,
      data: {
        adminNote
      }
    });
  };

  searchPeopleDetail = async (userId) => {
    return this.instance({
      method: this.searchPeopleDetailConfig.Method,
      url: `${this.searchPeopleDetailConfig.Endpoint}?userId=${userId}`,
      headers: {},
    });
  };

  getUsersSummary = async () => {
    return this.instance({
      method: this.usersSummaryConfig.Method,
      url: this.usersSummaryConfig.Endpoint,
    });
  };

  getUserEnquiry = async () => {
    return this.instance({
      method: this.UserEnquiryConfig.Method,
      url: this.UserEnquiryConfig.Endpoint,
    });
  };

  getFeatureAccess = async () => {
    return this.instance({
      method: this.userFeatureAccessConfig.Method,
      url: this.userFeatureAccessConfig.Endpoint,
      headers: {},
    });
  };

  getUserDailyAnalytics = async (userId) => {
    return this.instance({
      method: this.userDailyConfig.Method,
      url: this.userDailyConfig.Endpoint(userId),
    });
  };

  getUserPageAnalytics = async (userId) => {
    return this.instance({
      method: this.userPagesConfig.Method,
      url: this.userPagesConfig.Endpoint(userId),
    });
  };

  getUserLessons = async (data) => {
    return this.instance({
      method: this.UserLessonConfig.Method,
      url: this.UserLessonConfig.Endpoint,
      headers: {},
      data: data,
    });
  };
  getUserStats = async (data) => {
    return this.instance({
      method: this.UserStatsConfig.Method,
      url: this.UserStatsConfig.Endpoint(data),
      headers: {},
      data: data,
    });
  };
  getAdminTenantRatingSummary = async (tenantId) => {
    return this.instance({
      method: this.adminTenantRatingSummaryConfig.Method,
      url: this.adminTenantRatingSummaryConfig.Endpoint(tenantId),
      headers: {},
    });
  };
  getAdminTenantRatingEvents = async (tenantId, page = 1, limit = 20) => {
    return this.instance({
      method: this.adminTenantRatingEventsConfig.Method,
      url: `${this.adminTenantRatingEventsConfig.Endpoint(tenantId)}?page=${page}&limit=${limit}`,
      headers: {},
    });
  };
}

export default User;
